import { Formik } from "formik"

import { JobDrawerTypes } from "./JobDrawer"
import JobListingsInner from "./JobListingsInner"

import { SelectOption } from "@components/elements/V2/Inputs/DropdownInput"
import { useJobAds } from "@stores/joblistings"
import React, { useMemo } from "react"

export interface FilterValues {
  search: string
  location: string
  department: string
  type: string
}

const INITIAL_VALUES: FilterValues = {
  search: "",
  location: "",
  department: "",
  type: "",
}

const ALL_OPTION: SelectOption = { label: "All", value: "" }

type Props = {
  drawerData: JobDrawerTypes
}

const JobListings = ({ drawerData }: Props) => {
  const { records, isLoading, error } = useJobAds()

  const locations = useMemo(
    () => [
      ALL_OPTION,
      ...Array.from(new Set(records.map((r) => r.site).filter(Boolean)))
        .sort()
        .map((s) => ({ label: s, value: s })),
    ],
    [records]
  )

  const departments = useMemo(
    () => [
      ALL_OPTION,
      ...Array.from(new Set(records.map((r) => r.department).filter(Boolean)))
        .sort()
        .map((d) => ({ label: d, value: d })),
    ],
    [records]
  )

  const employmentTypes = useMemo(
    () => [
      ALL_OPTION,
      ...Array.from(
        new Set(records.map((r) => r.employmentType).filter(Boolean))
      )
        .sort()
        .map((t) => ({ label: t, value: t })),
    ],
    [records]
  )

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={() => {}}>
      <JobListingsInner
        isLoading={isLoading}
        error={error}
        records={records}
        locations={locations}
        departments={departments}
        employmentTypes={employmentTypes}
        drawerData={drawerData}
      />
    </Formik>
  )
}

export default JobListings
